export default "__VITE_ASSET__DGcUmuFQ__"